
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useTina } from "tinacms/dist/react";
import client from "../../../tina/__generated__/client";
import LessonPage from "@/modules/lessons/LessonPage";
import LessonBoard from "@/modules/lessons/Lessonboard";
const LessonDetailPage = (props) => {
    const { data } = useTina({
        query: props.query,
        variables: props.variables,
        data: props.data,
    });
    if (!data || !data.lesson) {
        return null;
    }
    const { lesson, introText, openingFen, openingLastMove, playingWhite, lines, challengeFen, challengeOpeningLastMove, challengeLines, lessonId, } = data.lesson;
    const slug = props.variables.relativePath.replace(".mdx", "");
    return (<LessonPage title={lesson}>
      <LessonBoard title={lesson} introText={introText} openingFen={openingFen ||
            "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"} openingLastMove={openingLastMove || ""} playingWhite={playingWhite ?? true} lines={lines || []} challengeFen={challengeFen || ""} challengeOpeningLastMove={challengeOpeningLastMove || ""} challengeLines={challengeLines || []} lessonId={lessonId || slug}/>
    </LessonPage>);
};
export const getStaticPaths = async ({ locales = [], }: {
    locales?: string[];
}) => {
    const lessonConnection = await client.queries.lessonConnection();
    const basePaths = [];
    lessonConnection.data.lessonConnection.edges.map((lesson) => {
        basePaths.push({
            params: {
                slug: lesson.node.slug,
            },
        });
    });
    const paths = locales.length > 0
        ? locales.flatMap((locale) => basePaths.map((path) => ({ ...path, locale })))
        : basePaths;
    return {
        paths,
        fallback: true,
    };
};
const getStaticProps = async ({ params }) => {
    const { slug } = params;
    const variables = {
        relativePath: `${slug}.mdx`,
    };
    const props = await client.queries.lesson(variables);
    return {
        props: { ...props },
    };
};
export default LessonDetailPage;

    async function __Next_Translate__getStaticProps__19cc3a5f8d9__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/learn/[slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19cc3a5f8d9__ as getStaticProps }
  